import useBackend from '@shared/hooks/useBackend'

import config from '@shared/config'

function masterData() {
  // HOOKS
  const { doGet, setup } = useBackend()

  // INIT
  setup('/masterdata', config.masterdataBaseUrl)

  // METHODS
  async function getDomesticLocations({ query, ...params }) {
    const payload = {
      zipLocation: (query || '').trim(),
      ...params,
    }
    const response = await doGet({ url: '/v2/locations/housekeys/domestic/zipLocation', params: payload })
    return response.zipLocationList
  }

  async function getHouseLocation({ housenumber, street, zipcode }) {
    const response = await doGet({ url: '/locations/houselocation', params: { housenumber, street, zipcode } })
    return response.data
  }

  async function getHouseNumbers({ housenumber, street, zipcode }) {
    const response = await doGet({ url: '/locations/housenumbers', params: { housenumber, street, zipcode } })
    return response.data
  }

  async function getStreets({ street, zipcode }) {
    const response = await doGet({ url: '/locations/streets', params: { street, zipcode } })
    return response.data
  }

  return {
    getHouseLocation,
    getHouseNumbers,
    getDomesticLocations,
    getStreets,
  }
}

export default masterData()
